import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import api from '@/lib/axios';
import { getErrorMessage } from '@/lib/errors';
import { tareasKeys } from '@/hooks/useTareas';

export type EventoAutomatico = 'presupuesto_enviado' | 'presupuesto_aceptado' | 'estudio_solicitado' | 'cita_cancelada';

export interface Automatizacion {
  evento: EventoAutomatico;
  titulo: string;
  descripcion: string;
  activo: boolean;
  diasVencimiento: number;
  tableroId: string | null;
  columnaId: string | null;
}

export interface CambioAutomatizacion {
  activo?: boolean;
  diasVencimiento?: number;
  tableroId?: string | null;
  columnaId?: string | null;
}

const CLAVE = [...tareasKeys.todas, 'automatizaciones'] as const;

export function useAutomatizaciones() {
  return useQuery<Automatizacion[]>({
    queryKey: CLAVE,
    queryFn: () => api.get('/api/tareas/configuracion/automatizaciones').then(r => r.data),
  });
}

export function useActualizarAutomatizacion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ evento, ...cambios }: { evento: EventoAutomatico } & CambioAutomatizacion) =>
      api.patch<Automatizacion[]>(`/api/tareas/configuracion/automatizaciones/${evento}`, cambios).then(r => r.data),
    onSuccess: lista => qc.setQueryData(CLAVE, lista),
    onError: e => toast.error(getErrorMessage(e, 'No se pudo guardar la automatización')),
  });
}
